<template>
  <span class="site-user-avatar" aria-hidden="true"><img v-if="src && !failed" :src="src" alt="" @error="failed=true"/><svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="8" r="3.5"/><path d="M5 21v-2a7 7 0 0 1 14 0v2"/></svg></span>
</template>
<script>
export default { name:'SiteUserAvatar', props:{src:{type:String,default:''}}, data(){return{failed:false};}, watch:{src(){this.failed=false;}} };
</script>
<style scoped>
.site-user-avatar{display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;flex:none;overflow:hidden;border-radius:50%;color:var(--salt-subtext,var(--color-text));background:var(--salt-sub-background,var(--color-secondary-bg));}
.site-user-avatar img{width:100%;height:100%;object-fit:cover;}
.site-user-avatar svg{width:75%;height:75%;}
</style>
